import React, { Component } from 'react';
import styled from '@emotion/styled';
import { Link } from '@utils';

import * as utils from '@utils';
import { colors, animation, respondFrom, breakpoints, css } from '@styles';
import { ConfiguratorBasket, Product } from '@store/types';
import { ConfiguratorActions } from '@store/actions';
import Icon from '@components/common/Icon';
import { LocationDependent } from '@content/types/general';
import { ConfiguratorSettings } from '@content/types/configuratorSettings';

const ButtonReturnContainer = styled.div<StyleProps>`
  display: none;

  ${respondFrom(
    breakpoints.lg,
    css`
      display: block;
    `
  )}
`;

const ButtonReturn = styled.div<StyleProps>`
  display: ${props => (props.isVisible ? 'block' : 'none')};
  margin-bottom: ${props => (props.isVisible ? '-30px' : '0')};
`;

const ReturnLink = styled(Link)`
  display: block;
  text-align: center;
  text-transform: uppercase;
  color: ${colors.ui.light};
  padding: 20px 0;

  span {
    display: inline-block;
    transition: ${animation.fast}ms ease-out;
    transition-property: transform;
  }

  svg {
    margin-right: 10px;
    transition: ${animation.fast}ms ease-out;
    transition-property: transform;
  }

  &:hover {
    text-decoration: none;

    span {
      transform: translateX(-1px);
    }

    svg {
      transform: rotate(180deg) translateX(4px);
    }
  }
`;

interface SummaryButtonReturnProps extends LocationDependent {
  basket: ConfiguratorBasket;
  activeStep: string;
  currentProductIndex: number;
  configuratorActions: typeof ConfiguratorActions;
  hideOnMobile?: boolean;
  pageSettings: ConfiguratorSettings;
  langcode: string;
  urls: Array<string>;
}

interface StyleProps {
  isVisible?: boolean;
  hideOnMobile?: boolean;
}

class ShoppingSummaryButtonReturn extends Component<SummaryButtonReturnProps> {
  getButtonPath = () => {
    const { basket, currentProductIndex, activeStep, location, langcode, urls } = this.props;

    let buttonPath;

    if (activeStep === 'colors') {
      const restOfProducts: Array<Product> = [];
      basket.products.map((p, i) => {
        if (i < currentProductIndex) {
          restOfProducts.push(p);
        }
      });

      if (currentProductIndex === 0) {
        buttonPath = utils.langLink(langcode, `${urls[4]}${utils.getBranchParameter(location)}`);
      } else {
        if (
          restOfProducts.find(product => utils.productHasAvailableColors(product)) === undefined
        ) {
          buttonPath = utils.langLink(langcode, `${urls[4]}${utils.getBranchParameter(location)}`);
        } else {
          buttonPath = utils.langLink(langcode, `${urls[9]}${utils.getBranchParameter(location)}`);
        }
      }
    } else if (activeStep === 'accessories') {
      const restOfProducts: Array<Product> = [];
      basket.products.map((p, i) => {
        if (i < currentProductIndex) {
          restOfProducts.push(p);
        }
      });
      if (currentProductIndex === 0) {
        if (basket.products.find(product => utils.productHasAvailableColors(product))) {
          buttonPath = utils.langLink(langcode, `${urls[9]}${utils.getBranchParameter(location)}`);
        } else {
          buttonPath = utils.langLink(langcode, `${urls[4]}${utils.getBranchParameter(location)}`);
        }
      } else {
        if (
          restOfProducts.find(product => utils.productHasAvailableAccessories(product)) === undefined
        ) {
          buttonPath = utils.langLink(langcode, `${urls[9]}${utils.getBranchParameter(location)}`);
        } else {
          buttonPath = utils.langLink(langcode, `${urls[10]}${utils.getBranchParameter(location)}`);
        }
      }
    } else if (activeStep === 'krok-2') {
      if(basket.products.find(product => utils.productHasAvailableAccessories(product))) {
        buttonPath = utils.langLink(langcode, `${urls[10]}${utils.getBranchParameter(location)}`);
      } else if(basket.products.find(product => utils.productHasAvailableColors(product))) {
        buttonPath = utils.langLink(langcode, `${urls[9]}${utils.getBranchParameter(location)}`);
      } else {
        buttonPath = utils.langLink(langcode, `${urls[4]}${utils.getBranchParameter(location)}`);
      }
    } else if (activeStep === 'krok-3') {
      buttonPath = utils.langLink(langcode, `${urls[6]}${utils.getBranchParameter(location)}`);
    } else if (activeStep === 'krok-4') {
      buttonPath = utils.langLink(langcode, `${urls[7]}${utils.getBranchParameter(location)}`);
    } else {
      buttonPath = utils.langLink(langcode, `${urls[4]}${utils.getBranchParameter(location)}`);
    }

    return buttonPath;
  };

  goToPrevProduct = () => {
    if (this.props.activeStep === 'colors' || this.props.activeStep === 'accessories') {
      if (this.props.currentProductIndex !== 0) {
        const restOfProducts: Array<Product> = [];
        this.props.basket.products.map((p, i) => {
          if (i < this.props.currentProductIndex) {
            restOfProducts.push(p);
          }
        });
        
        const checkProducts = restOfProducts.map(product => {
          if (this.props.activeStep === 'colors') {
            return utils.productHasAvailableColors(product) ? true : false
          } else if(this.props.activeStep === 'accessories') {
            return utils.productHasAvailableAccessories(product) ? true : false
          }
        })
        
        const lastIndex = checkProducts.lastIndexOf(true);
        if (lastIndex !== -1) {
          this.props.configuratorActions.setCurrentProductIndex(lastIndex);
        } else {
          this.props.configuratorActions.setCurrentProductIndex(this.props.currentProductIndex - 1);
        }
      }
    }
  };

  render() {
    const { activeStep, hideOnMobile, pageSettings } = this.props;
    const isVisible = activeStep === 'krok-1' ? false : true;

    return (
      <ButtonReturnContainer hideOnMobile={hideOnMobile}>
        <ButtonReturn isVisible={isVisible} onClick={this.goToPrevProduct}>
          <ReturnLink to={this.getButtonPath()}>
            <Icon className="button-icon" type="arrow-left" inheritColor={true}></Icon>
            <span>{pageSettings.field_proste_pola[24]}</span>
          </ReturnLink>
        </ButtonReturn>
      </ButtonReturnContainer>
    );
  }
}

export default ShoppingSummaryButtonReturn;
